<template>
  <!-- «واتساب ميتا» in a send dropdown, for the pages whose send choices are only a dropdown (tables: one per row /
       column). Same behaviour as <meta-send-button>: emits `send`, or (locked) the «واتساب ميتا غير مفعّل» dialog. -->
  <b-dropdown-item
    :class="['mc-item', locked ? 'mc-item-locked' : 'mc-item-ready']"
    :aria-label="label + (locked ? ' — غير مفعّل' : '')"
    @click="click"
  >
    <feather-icon :icon="locked ? 'LockIcon' : 'CheckCircleIcon'" size="14" class="mc-item-ico" />
    {{ label }}
  </b-dropdown-item>
</template>

<script>
import { BDropdownItem } from 'bootstrap-vue'
import { META_BUTTON, metaState, metaStateNow, metaPick } from '@/libs/meta-channel'

export default {
  name: 'MetaSendItem',
  components: { BDropdownItem },
  props: {
    label: { type: String, default: META_BUTTON },
  },
  data() {
    return { s: metaStateNow() }
  },
  computed: {
    locked() {
      return !this.s.ready
    },
  },
  created() {
    metaState()
  },
  methods: {
    click() {
      var g = this
      metaPick(g).then(function (ok) {
        if (ok) g.$emit('send')
      })
    },
  },
}
</script>
